import { useApi } from "../../../contexts/app/provider";
import { useGetMyDataHubPullFilesQuery } from "../../../services/api/__generated__/backend_gateway-types";
import { DataPullsPanelComponent } from "./component";

export const DataPullsPanelContainer = () => {
  const { apiService } = useApi();

  const { data, loading, error } = useGetMyDataHubPullFilesQuery({
    client: apiService.getClient(),
  });

  // The panel is informational — if the report errors or the org has no pull
  // config, Run History should look exactly like it did before.
  if (error) {
    return null;
  }
  const report = data?.getMyDataHubPullFiles || null;
  if (!loading && (!report || report.sources.length === 0)) {
    return null;
  }

  return <DataPullsPanelComponent loading={loading} report={report} />;
};
